import netflix from '../assets/projects/netflix.jpg';
import hulu from '../assets/projects/hulu.jpg';
import realEstate from '../assets/projects/real-estate.jpg';
import cocktail from '../assets/projects/cocktail.jpg';
import covidTracker from '../assets/projects/covid.jpg';
import github from '../assets/projects/github.png';
import weather from '../assets/projects/weather.jpg';
import stripe from '../assets/projects/stripe.jpg';
import expense from '../assets/projects/expense.jpg';

export const projects = [
  {
    id: 1,
    name: 'Netflix-Clone',
    description: 'Built with ReactJs, TMDB API, Firebase and Redux',
    image: netflix,
    sourceCode: 'https://github.com/KenWhite02/fullstack-netflix',
    website: 'https://netflix-clone-cc6de.web.app/',
    about:
      'https://github.com/KenWhite02/fullstack-netflix/blob/main/README.md',
  },
  {
    id: 2,
    name: 'Hulu-Clone',
    description: 'Built with NextJs, TMDB API and Tailwind Css',
    image: hulu,
    sourceCode: 'https://github.com/KenWhite02/trailer-tube',
    website: 'https://ken-hulu.vercel.app/',
    about: 'https://github.com/KenWhite02/trailer-tube/blob/main/README.md',
  },
  {
    id: 3,
    name: 'Real-Estate',
    description: 'Built with NextJs, Bayut API and Chakra-UI',
    image: realEstate,
    sourceCode: 'https://github.com/KenWhite02/real-estate-nextjs',
    website: 'https://ken-real-estate.vercel.app/',
    about:
      'https://github.com/KenWhite02/real-estate-nextjs/blob/main/README.md',
  },
  {
    id: 4,
    name: 'Cocktail DB',
    description: 'Built with ReactJs and CocktailDB API',
    image: cocktail,
    sourceCode: 'https://github.com/KenWhite02/cocktailDB',
    website: 'https://ken-cocktails.netlify.app/',
    about: 'https://github.com/KenWhite02/cocktailDB/blob/main/README.md',
  },
  {
    id: 5,
    name: 'Covid Tracker',
    description: 'Built with ReactJs, React-leaflet and Material-UI',
    image: covidTracker,
    sourceCode: 'https://github.com/KenWhite02/covid-tracker',
    website: 'https://rona-19-tracker.netlify.app/',
    about: 'https://github.com/KenWhite02/covid-tracker/blob/main/README.md',
  },
  {
    id: 6,
    name: 'Github Tracker',
    description: 'Built with ReactJs and Github API',
    image: github,
    sourceCode: 'https://github.com/KenWhite02/github-tracker',
    website: 'https://ken-github-tracker.netlify.app/',
    about: 'https://github.com/KenWhite02/github-tracker/blob/main/README.md',
  },
  {
    id: 7,
    name: 'Weather App',
    description: 'Built with ReactJs and OpenWeatherMap API',
    image: weather,
    sourceCode: 'https://github.com/KenWhite02/weather-app',
    website: 'https://whitish-weather.netlify.app/',
    about: 'https://github.com/KenWhite02/weather-app/blob/main/README.md',
  },
  {
    id: 8,
    name: 'Stripe Menus',
    description: 'Built with ReactJs',
    image: stripe,
    sourceCode: 'https://github.com/KenWhite02/stripe-submenus',
    website: 'https://ken-stripe-menus.netlify.app/',
    about: 'https://github.com/KenWhite02/stripe-submenus/blob/main/README.md',
  },
  {
    id: 9,
    name: 'Expense Tracker',
    description: 'Built with ReactJs and Speechly',
    image: expense,
    sourceCode: 'https://github.com/KenWhite02/expense-tracker',
    website: 'https://ken-expense-tracker.netlify.app/',
    about: 'https://github.com/KenWhite02/expense-tracker/blob/main/README.md',
  },
];
